// extracted by mini-css-extract-plugin
module.exports = {"EmptyButton":"style_EmptyButton__m-Qsb"};